/* eslint-disable @nx/enforce-module-boundaries */
import { Card, HStack,Box, VStack, Stack } from '@mybridge/ui';
import { forwardRef } from 'react';
import { JobDetails } from 'v4/snippets/jobs/job-details';
import { JobsListingLayout } from 'v4/snippets/jobs/layout';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { isMobile } from 'react-device-detect';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
export const JobDetailsPage = forwardRef(({ ...props }, ref) => {
  return (
    <AuthenticatedProviders>
       <HStack spacing={2} alignItems="flex-start" flexGrow={1} maxW="1300px">
        {!isMobile &&
         <HStack pos={!isMobile && "sticky"} top={!isMobile && "64px"} maxH={!isMobile && "500px"} alignItems="stretch" spacing={0}>
         <Stack
           display={['none', 'none', 'flex']}
           pos="sticky"
           top="64px"
           spacing={2}
           minH="100vh"
           borderBottom="1px solid #e0e0e094"
           height={'500px'}
           zIndex="999"
         >
           <VStack
             spacing={2}
             justifyContent="space-between"
             height="100%"
             align="stretch"
             h="calc(100vh - 0px)"
             backgroundColor="rgb(255, 255, 255)"
           >
             <VStack spacing={2} align="stretch" h="100%" flex="1">
               <SiteShortcutLinks />
               <Box
               //  className={styles.hideTitle}
               >
                 <DashboardMyCircle h="300px" flex="1" />
               </Box>
             </VStack>
           </VStack>
         </Stack>
       </HStack>
        }
      <JobsListingLayout showSearchBar={false}>
        <Card my={6} mt={2} boxShadow="none" px={2}>
          <JobDetails />
        </Card>
      </JobsListingLayout>
      </HStack>
    </AuthenticatedProviders>
  );
});

export default JobDetailsPage;
